"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolbarSizeContext = void 0;
var _lodestarUtils = require("@smartsheet/lodestar-utils");
/**
 * Used to keep track of the stack size of a collapsible toolbar.
 *
 * This context is only used when the toolbar is collapsible. A value is provided to it regardless.
 *
 */
const ToolbarSizeContext = (0, _lodestarUtils.createContext)({
  isCollapsible: false,
  toolbarSize: "large"
}, "ToolbarSizeContext");
exports.ToolbarSizeContext = ToolbarSizeContext;
//# sourceMappingURL=ToolbarSizeContext.js.map